export const ClearSaleReliabilityList = [
  { label: 'Risco muito baixo', min: 0, max: 9, color: '#2F2EE6' },
  { label: 'Risco baixo', min: 10, max: 45, color: '#45B12E' },
  { label: 'Risco médio', min: 46, max: 79, color: '#FFB952' },
  { label: 'Risco alto', min: 80, max: 89, color: '#F67701' },
  { label: 'Risco muito alto', min: 90, max: 100, color: '#E2001B' },
];
